import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { ToastService } from '../../../core/services/toast/toast.service';
import { DelegatedUIErrorI } from '../../../shared/interfaces/delegated-ui-error.interface';
import { FacultiesApiService } from '../faculties-api.service';
import { FacultyI } from '../interfaces/faculty.interface';
import { FacultiesDetailsSideMenuComponent } from './faculties-details-side-menu/faculties-details-side-menu.component';
import { FacultiesService } from '../faculties.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-faculties-details',
  imports: [FacultiesDetailsSideMenuComponent, TranslateModule, RouterOutlet],
  templateUrl: './faculties-details.component.html',
  styleUrl: './faculties-details.component.scss',
})
export class FacultiesDetailsComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly translateService = inject(TranslateService);
  private readonly toastService = inject(ToastService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly facultiesApiService = inject(FacultiesApiService);
  private readonly facultiesService = inject(FacultiesService);
  private destroyRef = inject(DestroyRef);

  facultyID: string | undefined = undefined;
  faculty: FacultyI | null = null;
  limit = 15;

  ngOnInit() {
    this.getFacultyIDFromRouteParams();
  }

  getFacultyIDFromRouteParams() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paramMap) => {
        const facultyID = paramMap.get('facultyID');
        if (!facultyID) {
          this.toastService.showError(
            this.translateService.instant('errors.contactTechnicalSupport')
          );
          this.location.back();
        } else {
          this.facultyID = facultyID;
          this.fetchFaculty();
        }
      });
  }

  fetchFaculty() {
    this.facultiesApiService
      .findOne(this.facultyID!)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.cd.detectChanges())
      )
      .subscribe({
        next: (findOneResponse) => {
          const { data } = findOneResponse;
          this.faculty = data;
          this.facultiesService.selectedFaculty.set(this.faculty);
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }
}
